import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Route } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import Donation from "./components/Donation/Donation";
import About from "./components/About/About";
import Navbar from "./components/Navbar/Navbar";
import MainBody from "./components/MainBody/MainBody";
import Footer from "./components/Footer/Footer";
import Contact from "./components/Contact/Contact";

import { setupStripe } from "./Functions/api";

const StyledApp = styled.div`
  background-color: ${(props) => props.theme.palette.secondary.main};
  text-align: center;

  // width: 100vw;
`;

function App() {
  const [forestDonations, setForestDonations] = useState([]);
  const [payment, setPayment] = useState(25);
  const changePayment = (newPayment) => (newPayment > 0 ? setPayment(newPayment) : setPayment(0));
  const [stripePromise, setStripePromise] = useState(null);

  const [totalDonations, setTotalDonations] = useState(null);
  const [treesPlanted, setTreesPlanted] = useState(0);
  const [forestLat, setForestLat] = useState(0);
  const [forestLng, setForestLng] = useState(0);

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      require("dotenv").config();
      setStripePromise(loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_TEST));
    } else {
      setStripePromise(loadStripe(process.env.REACT_APP_STRIPE_PUBLIC));
    }
    // setupStripe().then((data) =>
    // setStripePromise(loadStripe(data.stripe_public_key))
    // );
  }, []);

  return (
    <Elements stripe={stripePromise}>
      <StyledApp>
        <Navbar />
        <Route exact path="/">
          <MainBody
            totalDonations={totalDonations}
            setTotalDonations={setTotalDonations}
            treesPlanted={treesPlanted}
            setTreesPlanted={setTreesPlanted}
            forestLat={forestLat}
            setForestLat={setForestLat}
            forestLng={forestLng}
            setForestLng={setForestLng}
            payment={payment}
            setPayment={changePayment}
            forestDonations={forestDonations}
            setForestDonations={setForestDonations}
          />
        </Route>

        <Route path="/donation">
          <Donation payment={payment} setPayment={changePayment} />
        </Route>

        <Route path="/about">
          <About />
        </Route>

        <Route path="/contact">
          <Contact />
        </Route>

        <Footer />
      </StyledApp>
    </Elements>
  );
}

export default App;
